/** Inline icons. No icon font or external request. */

import type { JSX } from "react";

type P = { className?: string };

const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export function TrophyIcon(p: P): JSX.Element {
  return (
    <svg {...base} {...p} aria-hidden>
      <path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0V4Z" />
      <path d="M17 5h3v2a3 3 0 0 1-3 3M7 5H4v2a3 3 0 0 0 3 3" />
    </svg>
  );
}

export function ChatIcon(p: P): JSX.Element {
  return (
    <svg {...base} {...p} aria-hidden>
      <path d="M21 12a8 8 0 0 1-8 8H8l-4 3v-5.5A8 8 0 0 1 4 12a8 8 0 0 1 8-8h1a8 8 0 0 1 8 8Z" />
    </svg>
  );
}

export function UserIcon(p: P): JSX.Element {
  return (
    <svg {...base} {...p} aria-hidden>
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5 20a7 7 0 0 1 14 0" />
    </svg>
  );
}

export function EyeIcon(p: P): JSX.Element {
  return (
    <svg {...base} {...p} aria-hidden>
      <path d="M2 12s3.6-6 10-6 10 6 10 6-3.6 6-10 6-10-6-10-6Z" />
      <circle cx="12" cy="12" r="2.5" />
    </svg>
  );
}

export function FootTrafficIcon(p: P): JSX.Element {
  return (
    <svg {...base} {...p} aria-hidden>
      <circle cx="8" cy="4.5" r="1.8" />
      <path d="M8 6.5v5l-2 8M8 11.5l3 3 1 5" />
      <circle cx="17" cy="6" r="1.5" />
      <path d="M17 8v4l2 7" />
    </svg>
  );
}

export function TruckIcon(p: P): JSX.Element {
  return (
    <svg {...base} {...p} aria-hidden>
      <path d="M2 7h11v9H2zM13 10h4l3 3v3h-7z" />
      <circle cx="6" cy="18" r="1.8" />
      <circle cx="17" cy="18" r="1.8" />
    </svg>
  );
}

export function PickaxeIcon(p: P): JSX.Element {
  return (
    <svg {...base} {...p} aria-hidden>
      <path d="M14 4c3 0 6 2 6 5-2.5-1-4.5-.5-6 1M14 4c-3 0-6 2-6 5 2.5-1 4.5-.5 6 1" />
      <path d="M13 11 4 20" />
    </svg>
  );
}

export function MapIcon(p: P): JSX.Element {
  return (
    <svg {...base} {...p} aria-hidden>
      <path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2Z" />
      <path d="M9 4v14M15 6v14" />
    </svg>
  );
}

export function DeedIcon(p: P): JSX.Element {
  return (
    <svg {...base} {...p} aria-hidden>
      <path d="M5 3h9l5 5v13H5z" />
      <path d="M14 3v5h5M8 13h8M8 17h5" />
    </svg>
  );
}

export function KeyIcon(p: P): JSX.Element {
  return (
    <svg {...base} {...p} aria-hidden>
      <circle cx="8" cy="8" r="4" />
      <path d="M11 11l9 9M17 17l2-2M14 14l2-2" />
    </svg>
  );
}

export function ExchangeIcon(p: P): JSX.Element {
  return (
    <svg {...base} {...p} aria-hidden>
      <path d="M4 8h13l-3-3M20 16H7l3 3" />
    </svg>
  );
}

export function BankIcon(p: P): JSX.Element {
  return (
    <svg {...base} {...p} aria-hidden>
      <path d="M3 10 12 4l9 6M5 10v9h14v-9M9 19v-5h6v5" />
    </svg>
  );
}

export function ChartIcon(p: P): JSX.Element {
  return (
    <svg {...base} {...p} aria-hidden>
      <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
    </svg>
  );
}
